import { Button, Flex, Form, message, Modal, Select, Input, DatePicker, Spin } from "antd";
import { observer } from "mobx-react-lite";
import { useStore } from "../../stores/root-store-context";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { Option } from "antd/es/mentions";

export const AddJobTitle = observer((props: { isModalOpen: boolean, hideModal: () => void, userId?: string }) => {
    const { isModalOpen, hideModal, userId } = props;
    const { employeesStore } = useStore();
    const [messageApi] = message.useMessage();
    const [form] = Form.useForm();
    const { t } = useTranslation();

    const onFinish = async () => {
        const title = form.getFieldValue("title");
        const description = form.getFieldValue("description");
        await employeesStore.addJobTitle(title, description).then(async (res: any) => {
            messageApi.success("Success");
            await employeesStore.editUser({
                id: userId,
                jobTitleId: res.data.id
            }).then(() => {
                employeesStore.getJobTitles();
                form.resetFields();
                hideModal();
                employeesStore.getUsers().catch(console.log)
            });
            return res;
        }).catch(console.log)
    };


    return (
        <Spin spinning={employeesStore.isLoading}>
            <Modal
                title="New Job Title"
                open={isModalOpen}
                footer={null}
                onCancel={() => {
                    hideModal();
                    form.resetFields();
                }}
            >
                <Form form={form} onFinish={onFinish} layout="vertical">
                    <Form.Item<any>
                        label={`${t("Title")}`}
                        name="title"
                        style={{ width: "100%" }}
                        rules={[{ required: true }]}
                    >
                        <Input
                            placeholder={`${t("Title")}`}
                        />
                    </Form.Item>
                    <Form.Item<any>
                        label={`${t("Description")}`}
                        name="description"
                        style={{ width: "100%" }}
                        rules={[{ required: true }]}
                    >
                        <Input
                            placeholder={`${t("Description")}`}
                        />
                    </Form.Item>

                    <Form.Item>
                        <Button
                            type="primary"
                            className="theme-btn"
                            htmlType="submit"
                            style={{ height: 65, float: "right" }}
                        >
                            {t("Save")} <i className="fa-solid fa-arrow-right-long" />
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </Spin>
    )
})